module.exports = __webpack_public_path__ + "img/mfd_in_2_pp1_name.07d0bba1.png";